/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { i as initialize } from './ionic-global-00475c3a.js';

const globalScripts = initialize;

export { globalScripts as g };
